import React from "react";

// TODO: implement the TemplateMenu component similar to ./LibraryMenu.tsx
// This is a placeholder for the TemplateMenu component which will handle templates in Excalidraw
// It should include functionality to load, save, and manage templates from individual user's library or shared templates(call it "showcase")

export const TemplateMenu = () => {
  return <div className="template-menu">Template Menu Placeholder</div>;
};
